import o from "tonweb";
import { pTON_VERSION as n } from "../constants.js";
const { Address: d, Contract: a } = o, s = class e extends a {
  constructor({ tonApiClient: r, stonApiClient: c, ...t }) {
    super(r, {
      ...t,
      address: t.address ?? e.address
    });
  }
};
s.version = n.v1;
s.address = new d(
  "EQCM3B12QK1e4yZSf8GtBRT0aLMNyEsBc_DhVfRRtOEffLez"
);
let V = s;
export {
  V as PtonV1
};
//# sourceMappingURL=PtonV1.js.map
